import React from "react";

const InputComponent = ({
  label,
  id,
  value,
  onChange,
  type = "text",
  placeholder = "",
  options = [],
  margin,
  fullWidth,
  SelectProps,
  disabled,
  validationRequired,
  labelClassName,
  selectClassName,
  inputClassName,
  error = "",
  onBlur
}) => {
  return (
    <div className={`mb-5  relative ${fullWidth ? "w-full" : ""}`}>
      <label
        htmlFor={id}
        className={`mb-1 text-gray-800 block font-semibold text-[14px] ${labelClassName}`}
      >
        {label}
        {validationRequired && <sup className=" text-red-500">*</sup>}
      </label>

      {type === "select" ? (
        <select
          id={id}
          value={value}
          onChange={onChange}
          className={`min-h-[45px] w-full px-5 outline-none border-2 border-gray-200 rounded-md focus:ring-blue-600 focus:border-blue-600 ${selectClassName} `}
          {...SelectProps}
        >
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      ) : (
        <input
          disabled={disabled}
          id={id}
          value={value}
          type={type}
          onChange={onChange}
          placeholder={placeholder}
          className={`min-h-[45px] w-full px-5 outline-none border-2 border-gray-200 rounded-md focus:ring-blue-600 focus:border-blue-600 ${inputClassName}`}
          onBlur={onBlur}
        />
      )}
      {error != "" && <div className=" text-red-500 text-sm">{error}</div>}
    </div>
  );
};

export default InputComponent;
